import React,{useLayoutEffect,useRef,useState} from 'react';
import {createPortal} from 'react-dom';
export default function OwnerBusinessMenu({anchor,onClose,children}){
 const ref=useRef(null),[position,setPosition]=useState({visibility:'hidden'});
 useLayoutEffect(()=>{
  const rect=anchor?.getBoundingClientRect();if(!rect)return;
  const mobile=window.innerWidth<=700;
  const height=ref.current?.getBoundingClientRect().height||240;
  setPosition(mobile?{left:12,right:12,bottom:12,top:'auto',width:'auto'}:{right:'auto',bottom:'auto',width:208,left:Math.max(12,Math.min(rect.right-208,window.innerWidth-220)),top:Math.max(12,Math.min(rect.bottom+6,window.innerHeight-height-12))});
  ref.current?.querySelector('a,button:not(:disabled)')?.focus();
 },[anchor]);
 const keys=event=>{
  const items=[...ref.current.querySelectorAll('a,button:not(:disabled)')];
  const index=items.indexOf(document.activeElement);
  if(event.key==='Escape'){event.preventDefault();onClose();anchor?.focus();}
  if(event.key==='ArrowDown'||event.key==='ArrowUp'){event.preventDefault();items[(index+(event.key==='ArrowDown'?1:-1)+items.length)%items.length]?.focus();}
 };
 return createPortal(<div ref={ref} className="owner-business-menu owner-business-menu-portal" role="menu" onKeyDown={keys} style={{...position,position:'fixed',zIndex:10000,maxHeight:'calc(100dvh - 24px)',overflowY:'auto',boxSizing:'border-box'}}>{children}</div>,document.body);
}
